<template>
<div>
    <template v-if="this.from == 'cust'">
        <base-header pageName="나만의 플랜" :prevBtnShow="true" :popup="true"></base-header>
    </template>
    <template v-else>
        <base-header pageName="나만의 플랜" :prevBtnShow="true"></base-header>
    </template>
    
    <section id="wrap">
        <div class="edu-myPlan">
            <p>총 <em>{{this.myPlanList.length}}</em>건의 플랜</p>
            <button type="button" @click="planReg" class="add">플랜등록</button>
            <ul>
            <template v-if="this.myPlanList.length > 0">
                <li v-for="(item, index) in myPlanList" :key="index" :class="{'focus' : item.selected}">
                    <span v-if="!item.selected">{{item.planNm}}</span>
                    <input type="text" v-else :value="item.planNm" v-on:input="changeName($event,index)">
                    <button v-if="!item.selected" @click="planEdit(item)" type="button" class="edit">편집</button>
                    <button v-else @click="planEdit(item)" type="button" class="update">완료</button>
                    <button @click="planDel(item,index)" type="button" class="del">삭제</button>
                </li>
            </template>
            <template v-else>
                <li class="dataNone">
                    등록된 플랜이 없습니다.<br/>
                    <b>나만의 플랜을 등록</b>해주세요.
                </li>
            </template>
            </ul>
        </div>
    </section>
</div>
</template>

<script>
export default {
  name: "my-plan",
  data() {
      return{
          edit: true,
          editState: true,
          myPlanList:[],
          from:'',
      };
  },
  methods: {
        planReg: function(){
            this.$router.push({ name: "plan-product", query: { myPlan: 'Y' ,from:this.from}}).catch(function() {});
        },
        
        changeName($event,index){
            if($event.target.value.length > 10){
                $event.target.value = $event.target.value.substr(0,10)
            }else{
                this.myPlanList[index].planNm = $event.target.value;
            }
            
        },
        planEdit: function(item){
            if(item.selected){
                var that = this;
                var params = {
                    epmMySqno: item.epmMySqno,
                    planNm: item.planNm,
                }
                this.$api.eduplan.myPlanReNm(params).then(function(data) {
                    if(data && data > 0){
                        alert("플랜명 변경에 성공 하였습니다.");
                        that.$set(item, 'selected', !item.selected);
                    }else{
                        alert("플랜명 변경에 실패 하였습니다.");
                    }
                })
                .catch(function(error) {
                    alert(error.rtMsg);
                });
            }else{
                this.$set(item, 'selected', !item.selected);
            }
        },
        planDel: function(item,index){
            
			if(confirm("플랜을 삭제하시겠습니까?")){
				var that = this
				var params = {
                    'epmMySqno': this.myPlanList[index].epmMySqno // item.epmMySqno,
				};
				this.$api.eduplan.myPlanDel(params)
                .then(function(data) {
					if(data && data > 0){
						alert("삭제되었습니다.");
						that.myPlanList.splice(index,1);
					}else{
						alert("삭제에 실패하였습니다.");
					}
				})
				.catch(function(error) {
						alert(error.rtMsg);
				});
			}

        },
        getPlanList: function(){ // 상품 리스트 호출
            var that = this;
            this.$api.eduplan.myPlan().then(function(data) {
                that.myPlanList = data.myPlanList;
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
        },
  },
  created: function() { 
    if(this.$route.query && this.$route.query.from){
        this.from = this.$route.query.from
    }

    this.getPlanList();
  },
};
</script>
